import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import breakpoint from 'styled-components-breakpoint';
import Button from './Button';
import SchemeCategoriesRu from './assets/scheme-categories-ru.svg';
import SchemeCategoriesRo from './assets/scheme-categories-ro.svg';
import LocaleCode from 'providers/LocaleCode';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 73px;
`;

const Title = styled.h2`
  font-weight: 700;
  font-size: 26px;
  line-height: 34px;
  color: #333333;
  padding: 0 20px;

  & > span:nth-of-type(2) {
    color: #2757f4;
  }

  ${breakpoint('tablet')`
    font-size: 46px;
    line-height: 60px;
    letter-spacing: 0.5px;
    padding: 0;
  `};
`;

const Image = styled.img`
  margin-bottom: 20px;
  max-width: calc(100% - 40px);
`;

const Categories = () => {
  return (
    <LocaleCode>
      {localeCode => (
        <Wrapper>
          <Title>
            <FormattedMessage
              id="homeredesign.categories.title1"
              defaultMessage="Начните продавать товары и услуги"
            />
            <br />
            <FormattedMessage
              id="homeredesign.categories.title2"
              defaultMessage="из любой категории"
            />
          </Title>
          <Image
            src={localeCode === 'ro' ? SchemeCategoriesRo : SchemeCategoriesRu}
            alt="example"
          />
          <a href="https://999.md/">
            <Button className="active">
              <FormattedMessage
                id="homeredesign.categories.others"
                defaultMessage="Другие категории"
              />
            </Button>
          </a>
        </Wrapper>
      )}
    </LocaleCode>
  );
};

export default Categories;



// WEBPACK FOOTER //
// ./src/routes/Home/Categories.js